import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { getReducers } from '../reducers';
import { idAuthMfaMiddleware } from '../middleware/idauth-mfa';
import type { PreloadedState } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const RESET_APP_STATE = 'RESET_APP_STATE';

const rootReducer = (state, action) => {
  const shouldResetAppState = action.type === RESET_APP_STATE;
  const stateToUpdate = shouldResetAppState ? action.data : state;

  return combineReducers(getReducers())(stateToUpdate, action);
};

export const createAppStore = (preloadedState: PreloadedState<RootState> = {}) =>
  configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(idAuthMfaMiddleware),
  });

export type RootState = ReturnType<typeof rootReducer>;

export type AppStore = ReturnType<typeof createAppStore>;
export type AppDispatch = AppStore['dispatch'];

// Use this throughout the app to receive a typed useDispatch meaning it knows about the shape of our store
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
